import { WindowLocation } from '@gatsbyjs/reach-router';
import WizardComponent from '..';
import { EnrollmentContextService } from '../../../hoc/context/enrollment/enrollment-context';
import { ContextService } from '../../../hoc/context/product/context';
import Flow, { FlowStep } from '../../flow/flow';
import Ineligibility from '../components/ineligibility';

interface RouteParams {
	questionGroup: string;
	id: string;
}

export const routes = {
	question: ':questionGroup/:id',
	ineligible: 'ineligible',
};

export class WizardFlow extends Flow {
	protected questionGroupNames: string[];

	constructor(
		path: string,
		ctxt: ContextService,
		enrollmentCtxt: EnrollmentContextService,
		parent?: Flow
	) {
		super(path, ctxt, enrollmentCtxt, parent);
		this.questionGroupNames = Object.keys(this.ctxt.json.questions);
	}

	get steps(): FlowStep[] {
		return [
			{
				path: routes.question,
				component: WizardComponent,
				flow: this,
			},
			{
				path: routes.ineligible,
				component: Ineligibility,
				flow: this,
			},
		];
	}

	next(location: WindowLocation, routeParams: RouteParams) {
		if (this.uri === location.pathname) {
			this.navigate(`${this.questionGroupNames[0]}/1${location.search}`, {
				replace: true,
			});
		} else if (this.isEnrollable()) {
			let questionNumber = +routeParams.id;
			questionNumber++;
			if (
				questionNumber >
				this.getEnabledQuestions(routeParams.questionGroup).length
			) {
				const nextQuestionGroup = this.getNextQuestionGroup(
					routeParams.questionGroup
				);
				if (nextQuestionGroup) {
					this.navigate(nextQuestionGroup + '/1');
				} else {
					this.onEnd(location);
				}
			} else {
				this.navigate(routeParams.questionGroup + '/' + questionNumber);
			}
		} else {
			this.navigate(routes.ineligible);
		}
	}

	// HELPER FUNCTIONS
	// ----------------------------------------------------------------------------

	protected isEnrollable() {
		return (
			this.ctxt.json.services.filter((service) =>
				service.isEligible(
					this.enrollmentCtxt.input.performer,
					this.enrollmentCtxt.input.questions,
					this.enrollmentCtxt.input.consents,
					this.enrollmentCtxt.input.discardedServices
				)
			).length > 0
		);
	}

	protected getEnabledQuestions(questionGroup: string) {
		return this.ctxt.json.filterQuestions(
			questionGroup,
			this.enrollmentCtxt.input.performer,
			this.enrollmentCtxt.input.discardedServices,
			this.enrollmentCtxt.input.questions
		);
	}

	protected getNextQuestionGroup(questionGroup: string): string {
		const nextIndex = this.questionGroupNames.indexOf(questionGroup) + 1;
		let nextQuestionGroup = this.questionGroupNames[nextIndex];

		if (
			nextQuestionGroup &&
			!this.getEnabledQuestions(nextQuestionGroup).length
		) {
			nextQuestionGroup = this.getNextQuestionGroup(nextQuestionGroup);
		}

		return nextQuestionGroup;
	}
}

export default WizardFlow;
